import { render, staticRenderFns } from "./CourseStatistics.vue?vue&type=template&id=70160033&scoped=true&"
import script from "./CourseStatistics.vue?vue&type=script&lang=js&"
export * from "./CourseStatistics.vue?vue&type=script&lang=js&"
import style0 from "./CourseStatistics.vue?vue&type=style&index=0&id=70160033&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70160033",
  null
  
)

export default component.exports